<template>
  <v-card :disabled="disabled" :flat="flat" @click="$emit('clicked')" :width="width">
    <v-card-title class="py-2 pr-0">
      <slot name="title"></slot>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <slot name="body"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Card',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    flat: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>